import { apiFetch, LOGIN_PATH } from "./client";
import type { MeResponse, User } from "./types";

export function getMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>("/api/auth/me");
}

export function login(username: string, password: string): Promise<{ user: User }> {
  return apiFetch<{ user: User }>(LOGIN_PATH, {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
}

export function logout(): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>("/api/auth/logout", {
    method: "POST",
  });
}
